import { render, staticRenderFns } from "./CourseConfigForm.vue?vue&type=template&id=5a0ac9b2&scoped=true"
import script from "./CourseConfigForm.vue?vue&type=script&lang=js"
export * from "./CourseConfigForm.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./CourseConfigForm.vue?vue&type=style&index=1&id=5a0ac9b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0ac9b2",
  null
  
)

export default component.exports